import { render, staticRenderFns } from "./transfer-warehouse-list.vue?vue&type=template&id=5bd64569&scoped=true&"
import script from "./transfer-warehouse-list.vue?vue&type=script&lang=ts&"
export * from "./transfer-warehouse-list.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-warehouse-list.vue?vue&type=style&index=0&id=5bd64569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd64569",
  null
  
)

export default component.exports